// Client portal feature toggles. Flip a flag here to show/hide a feature across the app.
// Must be kept in sync with the backend `Features` section in appsettings.json.

export const features = {
  identityVerification: false,
};

export default features;
